import * as React from "react";
import {ReactElement, useEffect} from "react";
import SelectDepartureCity from "../SelectDepartureCity";
import {useSetStoreValue, useStoreValue} from "react-context-hook";
import {getConfiguration, getText} from "../../services/configuration.service";
import {fetchEndpoint} from "../../services/data.service";
import {IBookingEngine} from "../index";
import SelectDuration from "../SelectDuration";
import BookingData from "../BookingData";
import SelectDepartureDate from "../SelectDepartureDate";
import BookingPrice from "../BookingPrice";
import BookingPax from "../BookingPax";
import PromoProduct from "../PromoProduct";
import SelectCapacity from "../SelectCapacity";
/**
 * MainLayout
 * @constructor
 */
const BookingEngine = (): ReactElement => {
    const setBookingEngineData = useSetStoreValue("bookingEngineData");
    const chooseCalendarDefaultDate = useStoreValue("calendarDefaultValue");
    const bookingEngineData = useStoreValue("bookingEngineData");

    const enableCapacity = bookingEngineData?.product?.location;

    useEffect(() => {
        const hash = window.location.hash;
        fetchEndpoint(getConfiguration().baseUrl+ (hash ? ("?" + hash.split("#")[1]) : ""), (bookingEngineResponse: IBookingEngine) => {
            setBookingEngineData(bookingEngineResponse);
        });
    }, []);

    return (
        <section className="cpt-booking-product overlay-control" id="cptBookingProduct">
            <div className="title">{getText("booking.title")}</div>
            <form id="bookingForm" className="form-control" action={getConfiguration().submitUrl} method={"POST"}>
                <div className="booking-overlay d-none"/>
                <div className="booking-content">
                    <SelectDepartureCity />

                    {enableCapacity &&
                        <SelectCapacity/>
                    }

                    {/* add error-style for error */}
                    <SelectDuration />
                    <PromoProduct />
                    {/*<div className="error-message">Sélectionnez une durée...</div>*/}
                    <SelectDepartureDate />
                    {chooseCalendarDefaultDate &&
                        <div className="calendar-error-message">{getText("booking.calendar.warning")}</div>
                    }
                    <BookingPax />
                </div>
                <BookingPrice />
                <BookingData />
            </form>
        </section>
    );
};

export default BookingEngine;
